export enum HallowABFlag {
  web_multi_step_form_ebook = "web_multi_step_form_ebook",
}
